// Core
import React from "react";

import css from "./style.scss";

const projects = [
  {
    title: "Rughster.js (WIP)",
    url: "https://github.com/peterugh/Rughster.js",
    linkText: "Github/peterugh/Rughster.js",
    description:
      "Work in progress: Library of pure js methods commonly reused in projects. Many of them are to replace jQuery methods to remove project overhead."
  },
  {
    title: "Peekaboo Rollovers",
    url: "https://github.com/peterugh/peekaboo-rollovers",
    linkText: "Github/peterugh/peekaboo-rollovers",
    description:
      "Pure JS or jQuery plugin to give a small rollover interaction to buttons. Drop in implementation with the ability to add options to make the plugin more robust."
  },
  {
    title: "WP Global Contact & Social Media Info",
    url: "https://github.com/peterugh/wp-contact-info",
    linkText: "Github/peterugh/wp-contact-info",
    description:
      "This plugin adds a page under the settings menu in the WordPress admin area where users can enter global contact and social media info. Built for a site I was working on, decided to make it public."
  },
  {
    title: "Perfect Fold Image Stretch",
    url: "https://github.com/peterugh/Perfect-Fold-Image-Stretch",
    linkText: "Github/peterugh/Perfect-Fold-Image-Stretch",
    description:
      "jQuery plugin to expand a container containing an image or image slideshow to a height with a bottom window offset. It's an enhancement of the CSS property <code>background-size: cover;</code>."
  },
  {
    title: "Skeleton Slide Show",
    url: "https://github.com/peterugh/Skeleton-Slide-Show",
    linkText: "Github/peterugh/Skeleton-Slide-Show",
    description:
      "Got tired of bloated sliders so this jQuery slide show plugin is extremely lightweight. There are no built in themes, but rather classes that can easily mold the appearance of the plugin to your needs."
  },
  {
    title: "Sliding Doors",
    url: "https://github.com/peterugh/Sliding-Doors",
    linkText: "Github/peterugh/Sliding-Doors",
    description:
      "jQuery plugin that creates a sliding panels ineraction with a set of containers or images. I built this plugin because the other ones sucked."
  }
];
class Labs extends React.Component {
  componentDidMount() {
    this.props.setParentState({ showVideo: false });
  }

  render() {
    return (
      <div className={ css.Labs }>
        <h2>Labs</h2>
        <p>
          Labs?
        </p>
      </div>
    );
  }
}

export default Labs;



// WEBPACK FOOTER //
// ./app/js/components/Labs/index.js